export const termsOfUse = {
  'сухой': {
    'сухая' : 'А',
    'нормальная' : 'А',
    'влажная' : 'Б',
  },
  'нормальный': {
    'сухая' : 'А',
    'нормальная' : 'Б',
    'влажная' : 'Б',
  },
  'влажный/мокрый': {
    'сухая' : 'Б',
    'нормальная' : 'Б',
    'влажная' : 'Б',
  },
}